/*globals com*/
import React, { useState, useEffect } from 'react';
import { configureSDK, initializeSDK, logoutSession } from '../TransmitWebSdk';
import AuthFlowComponent from './AuthFlowComponent';
import BaseUIHandler from '../utils/BaseUIHandler';
import * as log from '../utils/log';
import { ThemeProvider } from 'styled-components';
import { findTheme } from '../branding/setTheme.js';
export default function AuthInitComponent(props) {
  const [transmitsdk, setTransmitsdk] = useState(null);
  const [transmitui, setTransmitui] = useState(null);
  const data = JSON.parse(props.config);
  const appData = {
    applicationId: data.appId,
    policyId: '',
    serverUrl: data.serverUrl
  };
  const list = data.authenticatorListing;
  const isQueueService = data.queueService;
  const maxAuthLevel = Object.keys(list).length;
  const brandingObj = data.brandingObj || {};
  const runtimeBranding = props.params.branding || {};
  const clientappCustomBranding = data.customStyles || {};
  const myTheme = findTheme(data.defaultUI, brandingObj, runtimeBranding, clientappCustomBranding);
  const handleTransmitSession = async xmSdk => {
    if (xmSdk?.currentSession) {
      await logoutSession(xmSdk, data.isLoggingEnabled).then(response => {
        if (data.isLoggingEnabled) {
          log.info('SDK logout success', response);
        }
      }).catch(error => {
        if (data.isLoggingEnabled) {
          log.info('SDK logout error', error);
        }
      });
    }
  };
  const handleAuthResponse = response => {
    if ('next_step' in response) {
      delete response['next_step'];
    }
    handleTransmitSession(transmitsdk);
    setTransmitsdk(null);
    setTransmitui(null);
    props.handleAuthResponse(response);
  };
  const initializeTransmit = async (xmSdk, xmUi) => {
    configureSDK(xmSdk, data.serverUrl, data.appId, data.crypto, props.params.app_env, data.isLoggingEnabled, data.secureaccess, data.OAuth2, props.params.bearer_token, data.internal);
    await initializeSDK(xmSdk, data.isLoggingEnabled).then(response => {
      if (response) {
        handleTransmitSession(xmSdk);
        setTransmitsdk(xmSdk);
        setTransmitui(xmUi);
      }
    }).catch(error => {
      if (data.isLoggingEnabled) {
        log.error('SDK initialize error', error);
      }
    });
  };
  useEffect(() => {
    //SDK dynamic loading
    if (!window.XmSdk || !window.xmui) {
      Promise.all([import("syf-transmit-library/dist/vendor/js/xmsdk.js"), import("syf-transmit-library/dist/vendor/js/xmui.js")]).then(([xmsdk, xmui]) => {
        const xmSdk = xmsdk.XmSdk();
        const xmUi = new xmui.XmUIHandler();
        window.XmSdk = xmSdk;
        window.xmui = xmUi;
        initializeTransmit(xmSdk, xmUi);
      }).catch(error => {
        if (data.isLoggingEnabled) {
          log.error('SDK import error', error);
        }
      });
    } else {
      initializeTransmit(window.XmSdk, window.xmui);
    }
  }, []);
  if (!transmitsdk) return null;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: myTheme
  }, /*#__PURE__*/React.createElement(AuthFlowComponent, {
    params: props.params,
    appData: appData,
    handleAuthResponse: handleAuthResponse,
    isQueueService: isQueueService,
    transmitsdk: transmitsdk,
    transmitui: transmitui,
    xmHandler: BaseUIHandler,
    maxAuthLevel: maxAuthLevel,
    theme: myTheme,
    analytics: data.analyticsObj,
    formatResponse: data.formatResponse,
    hasAnalytics: data.analytics,
    config: data,
    list: list,
    isLoggingEnabled: data.isLoggingEnabled,
    isVoiceEnabled: data.isVoiceEnabled,
    getComponent: () => import('../baseComponents/IovationCheckSdkComponent')
  }));
}